// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"418b6089","438":"1289f5b2","552":"e7e6ff9e","768":"0205b870"}[chunkId] + ".chunk.js";
};